import React, { useState } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import GoalsPageContainerComponent from './GoalsPageContainer/GoalsPageContainer.container';

const GoalsPage = ({ isSideBarOpened = false, t, ...props }) => {
    const staticNames = (t && t.offersPage && t.offersPage.goalsList) || {};

    return (
        <React.Fragment>
            <div className={isSideBarOpened ? "page-heading active-sidebar" : "page-heading"}>
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className={isSideBarOpened ? "wrapper-content offers active-sidebar" : "wrapper-content offers"}>
                <div className="ibox">
                    <GoalsPageContainerComponent />
                </div>
            </section>
        </React.Fragment>
    );
};

GoalsPage.propTypes = {
    isSideBarOpened: PropTypes.bool,
    t: PropTypes.object
};

export default withTranslation(GoalsPage);